export const bankList = [
  { code: "004", name: "臺灣銀行" },
  { code: "005", name: "臺灣土地銀行" },
  { code: "006", name: "合作金庫銀行" },
  { code: "007", name: "第一銀行" },
  { code: "008", name: "華南銀行" },
  { code: "009", name: "彰化銀行" },
  { code: "011", name: "上海商銀" },
  { code: "012", name: "台北富邦" },
  { code: "013", name: "國泰世華" },
  { code: "016", name: "高雄銀行" },
  { code: "017", name: "兆豐銀行" },
  { code: "021", name: "花旗(台灣)銀行" },
  { code: "050", name: "臺灣中小企業銀行" },
  { code: "052", name: "渣打銀行" },
  { code: "053", name: "台中銀行" },
  { code: "054", name: "京城銀行" },
  { code: "081", name: "滙豐銀行" },
  { code: "102", name: "華泰銀行" },
  { code: "103", name: "新光銀行" },
  { code: "108", name: "陽信銀行" },
  { code: "118", name: "板信銀行" },
  { code: "803", name: "聯邦銀行" },
  { code: "806", name: "元大銀行" },
  { code: "807", name: "永豐銀行" },
  { code: "808", name: "玉山銀行" },
  { code: "809", name: "凱基銀行" },
  { code: "810", name: "星展銀行" },
  { code: "812", name: "台新銀行" },
  { code: "816", name: "安泰銀行" },
  { code: "822", name: "中國信託" },
];